export const LOGO_URL = "https://customer-assets-lqy194kg.emergentagent.net/job_tuft-redesign/artifacts/97hq9heb_3F4AF4D9-6306-442E-A969-83AD57768E65.PNG";

export const DEFAULT_CONTENT = {
  site: {
    business_name: "That's Tuft Creative Co.",
    logo_image: LOGO_URL,
    email: "info@thatstuft.com",
    phone: "",
    address_line1: "26 Webster St., Floor 2",
    address_line2: "North Tonawanda, NY 14120",
    hours: "By appointment & booked workshops.\nSee workshop schedule for available times.",
    instagram_link: "https://instagram.com",
    facebook_link: "https://facebook.com",
    header_button_label: "Book Now",
    header_button_link: "/workshops",
    footer_heading_line1: "Let's",
    footer_heading_line2: "Tuft.",
    footer_tagline: "Where Creativity Gets Cozy — book a workshop, plan an event, or bring a creative experience to your team.",
  },
  home: {
    sections: [
      { id: "hero", label: "Hero", hidden: false },
      { id: "services", label: "What We Do", hidden: false },
      { id: "how_it_works", label: "How It Works", hidden: false },
      { id: "featured", label: "Featured Workshops", hidden: false },
      { id: "corporate", label: "Corporate Callout", hidden: false },
      { id: "testimonials", label: "Testimonials", hidden: false },
    ],
    hero: {
      badge: "Buffalo · North Tonawanda",
      heading_line1: "Where", heading_accent1: "Creativity",
      heading_line2: "Gets", heading_accent2: "Cozy.",
      description: "Create your own rug, celebrate with friends, book a private event, or bring a creative experience directly to your organization.",
      button1_label: "Book a Workshop", button1_link: "/workshops",
      button2_label: "Plan an Event", button2_link: "/private-events",
      image: "https://images.unsplash.com/photo-1700170726155-fe844921b8b3?crop=entropy&cs=srgb&fm=jpg&q=85",
      badge_label: "Loved by", badge_value: "1,200+ tufters",
    },
    services: {
      eyebrow: "What we do", heading: "Creative experiences,", heading_accent: "made cozy.",
      description: "From tiny toddlers to Fortune 500 teams — we run warm, professional creative experiences.",
      items: [
        { title: "Rug Tufting Workshops", description: "Learn the craft in a warm, guided studio session.", link: "/workshops", image: "https://images.unsplash.com/photo-1522065893269-6fd20f6d7438", large: true },
        { title: "Sip", description: "BYOB creative nights.", link: "/workshops", image: "https://images.unsplash.com/photo-1574883140236-2e2cb0835792" },
        { title: "Private Parties", description: "Birthdays, girls' nights, celebrations.", link: "/private-events", image: "", color: "ochre" },
        { title: "Corporate Events", description: "Team building that people remember.", link: "/corporate", image: "https://images.unsplash.com/photo-1757085242641-d829ddde7191" },
        { title: "Mobile Events", description: "We bring the studio to you.", link: "/corporate", image: "", color: "forest" },
        { title: "Custom Rugs", description: "Handmade, one-of-a-kind rugs.", link: "/custom-rugs", image: "https://images.pexels.com/photos/35769473/pexels-photo-35769473.jpeg" },
        { title: "Tuft Buddies", description: "Stuffed friends that make memories.", link: "/tuft-buddies", image: "", color: "coral" },
      ],
    },
    how_it_works: {
      eyebrow: "How Tufting Works", heading: "No experience", heading_accent: "needed.",
      description: "We handle the tricky parts. You focus on being creative.",
      steps: [
        { title: "Choose Your Design", description: "Pick a themed design or submit your own artwork before the workshop." },
        { title: "Arrive Ready to Tuft", description: "Your design is already traced and stretched onto your frame." },
        { title: "Tuft Your Rug", description: "We teach you how to safely use the tufting gun and guide you throughout." },
        { title: "Finish & Seal", description: "Your rug is finished using our backing process for durability." },
        { title: "Take It Home", description: "When same-day finishing is available, you leave with your completed rug." },
      ],
    },
    featured: { eyebrow: "Upcoming", heading: "Featured", heading_accent: "workshops", link_label: "See all" },
    corporate: {
      eyebrow: "For teams & organizations", heading: "Creative experiences that", heading_accent: "bring people together.",
      description: "Corporate team-building, conference activations, school programming, and community events — in our studio or brought directly to yours.",
      button_label: "Request a Quote", button_link: "/corporate",
      image: "https://images.unsplash.com/photo-1757085242641-d829ddde7191",
    },
    testimonials: {
      heading: "Real people,", heading_accent1: "real", heading_accent2: "rugs.",
      rating: "5.0", reviews_label: "8 Google reviews",
      reviews_link: "https://www.google.com/maps/place/That%27s+Tuft+Creative+Co.",
    },
  },
  pages: {
    workshops: { eyebrow: "Book a workshop", heading: "Find your creative night.", description: "Filter by experience below. Same-day finishing available for most workshops." },
    themes: { eyebrow: "Book by theme", heading: "Pick your", heading_accent: "theme.", description: "Ready-to-tuft themed designs — pre-drawn by our team so you can jump straight into the fun." },
    private_events: { eyebrow: "Private events", heading: "Your celebration, cozied up.", description: "Book the studio just for your group, or let us bring the experience to your space." },
    corporate: { eyebrow: "Corporate & mobile events", heading: "Creative experiences that bring people together.", description: "Corporate team-building, employee appreciation, mobile activations, conference programming, and community events — professionally run, warmly delivered." },
    custom_rugs: { eyebrow: "Custom rugs", heading: "Handmade, just for you.", description: "Custom rugs are handmade in our studio. Tell us about your vision — we'll follow up with a detailed quote. Final pricing depends on size and design complexity." },
    patch_hat_bar: { eyebrow: "Patch Hat Bar", heading: "Design your", heading_accent: "own hat.", included_heading: "Included per guest", form_heading: "Book your Patch Hat Bar" },
    tuft_buddies: {
      eyebrow: "Tuft buddies", heading: "Meet Your New Tuft Buddy.",
      description: "A playful adoption experience where kids (and grown-ups) create their own tufted best friend.",
      button1_label: "Book a Tuft Buddy Experience", button1_link: "/workshops",
      button2_label: "Plan a Tuft Buddy Party", button2_link: "/private-events",
      image: "https://images.pexels.com/photos/35769473/pexels-photo-35769473.jpeg",
      steps_heading: "The adoption experience",
      steps: [
        { title: "Choose your buddy", description: "Pick from a lineup of cozy characters." },
        { title: "Stuff your buddy", description: "Give them just the right amount of squish." },
        { title: "Add accessories", description: "Bows, patches, hats — make them yours." },
        { title: "Complete the adoption", description: "Name them and receive their adoption certificate." },
        { title: "Take your new friend home", description: "Bring your buddy home for a lifetime of snuggles." },
      ],
    },
    community: {
      eyebrow: "Sponsored community arts program", heading: "Creativity for everyone.",
      description: "Our sponsored community arts program brings creative experiences to youth, community organizations, and neighbors who might not otherwise have access.",
      image: "https://images.unsplash.com/photo-1757085242641-d829ddde7191",
      programs_heading: "What sponsored programming may include",
      programs: [{ title: "Youth Rug Tufting" }, { title: "Community Workshops" }, { title: "Open Studio Days" }, { title: "Guided Art Projects" }],
      cards: [
        { title: "Support the Program", description: "Contribute supplies, funding, or your time." },
        { title: "Become a Community Partner", description: "Partner with us to host programming for your group." },
        { title: "Join the Interest List", description: "Get notified when new sessions open." },
      ],
      form_heading: "Join the interest list", form_button_label: "Join",
    },
    gift_cards: {
      eyebrow: "Gift cards", heading: "The gift of creativity.", description: "Redeemable for any workshop, private event, or custom rug.",
      preset_amounts: "25, 50, 75, 100, 150, 250", minimum_amount: 5,
      footnote: "Secure checkout via Square.",
    },
    gallery: { eyebrow: "Gallery", heading: "Real moments, real rugs." },
    contact: {
      eyebrow: "Contact", heading: "Say hi.", description: "Visit the studio, email us, or book directly online.",
      map_link: "https://maps.google.com/maps?q=26%20Webster%20St%2C%20North%20Tonawanda%2C%20NY%2014120&t=&z=15&ie=UTF8&iwloc=&output=embed",
    },
  },
  policies: {
    refund: { title: "Refund Policy", body: "Workshop bookings are non-refundable but may be rescheduled up to 48 hours in advance, subject to availability.\n\nPrivate event deposits are non-refundable within 14 days of the event date.\n\nCustom rugs are made-to-order and are non-refundable once production has begun.\n\nGift cards are non-refundable and do not expire." },
    terms: { title: "Terms & Conditions", body: "By booking with That's Tuft Creative Co., you agree to our studio policies.\n\nAll bookings are subject to availability and confirmation. Event dates are not officially reserved until we approve the request and required payment or deposit is received.\n\nThe tufting gun and studio tools are provided for your use during the session. Guests are expected to follow safety instructions at all times." },
    privacy: { title: "Privacy Policy", body: "This website is operated by That's Tuft Creative Co. We collect information you provide directly (name, email, phone, event details, payment info processed by Square).\n\nWe use this information to process bookings, respond to inquiries, and send transactional communications via our email provider (Resend).\n\nWe do not store raw credit card information. All payments are processed securely by Square.\n\nWe do not sell your data. For questions, email info@thatstuft.com." },
    safety: { title: "Studio Safety", body: "Rug tufting uses powered tools. Please follow all guidance from our instructors.\n\nClosed-toe shoes are recommended. Loose clothing, long jewelry, and hair should be tied back.\n\nMinimum age varies by workshop. Youth workshops have parent/guardian supervision requirements." },
  },
};

const isObj = (v) => v && typeof v === "object" && !Array.isArray(v);
export function mergeContent(defaults, saved) {
  if (!isObj(saved)) return defaults;
  const out = { ...defaults };
  for (const k of Object.keys(saved)) {
    out[k] = isObj(defaults[k]) && isObj(saved[k]) ? mergeContent(defaults[k], saved[k]) : saved[k];
  }
  return out;
}
